import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, unref as _unref, createVNode as _createVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "flex flex-col mt-[56px] lg:px-6 mb-8" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("p", { class: "text-[15px] lg:text-[17px] font-semibold leading-[22px]" }, [
  /*#__PURE__*/_createTextVNode(" Email "),
  /*#__PURE__*/_createElementVNode("span", { class: "text-error" }, "*")
], -1)
const _hoisted_3 = {
  key: 0,
  class: "error-message"
}

import { Field, useField } from 'vee-validate';


export default {
  __name: 'EmailField',
  setup(__props) {

const { errorMessage } = useField('email');

return (_ctx, _cache) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _createVNode(_unref(Field), {
      name: "email",
      class: "m-0 rounded-lg bg-light p-4 text-[15px] leading-6",
      placeholder: "Wpisz swój email"
    }),
    (_unref(errorMessage))
      ? (_openBlock(), _createElementBlock("p", _hoisted_3, _toDisplayString(_unref(errorMessage)), 1))
      : _createCommentVNode("", true)
  ]))
}
}

}